<template>
    <div>
        <!-- <h1 class="display-heading mb-3">{{title}}<i v-if="isFamily" class="ml-2 fas fa-question-circle fa-xl" data-toggle="tooltip" :title="getTitleLabel()"></i></h1> -->
        <h1 class="display-heading mb-3">{{title}}</h1>
        <div class="table-responsive">
            <div ref="tableSection">
                <div class="d-flex align-items-baseline">
                    <div v-if="isFamily" class="form-group mr-3 d-flex align-items-baseline">
                        <label class="mr-2 font-weight-bold">Patient Name:</label>
                        <input style="width: 150px" type="text" name="filterName" data-vv-as="filter patient name" data-vv-validate-on="blur"
                            v-model="filterName" v-validate="''"
                            :class="{
                                'form-control': true,
                                'is-invalid':  validationErrors.has('filterName')
                            }">
                        <div v-show="validationErrors.has('filterName')" class="invalid-feedback">
                            {{ validationErrors.first('filterName') }}
                        </div>
                    </div>
                    <div class="form-group mr-3 d-flex align-items-baseline">
                        <label class="mr-2 font-weight-bold">Date:</label>
                        <input style="width: 150px" ref="filterDate" type="text" name="filterDate" data-vv-as="filter date" data-vv-validate-on="blur"
                            v-model="filterDate"
                            v-mask="'##/##/####'"
                            placeholder="DD/MM/YYYY"
                            :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('filterDate')
                        }" />
                        <div v-show="validationErrors.has('filterDate')" class="invalid-feedback">
                            {{ validationErrors.first('filterDate') }}
                        </div>
                    </div>
                    <div v-if="!isFamily" class="form-group mr-2 d-flex align-items-baseline">
                        <label class="mr-2 font-weight-bold">IC:</label>
                        <select class="form-control mr-2" style="width: 120px;" v-model="icType">
                            <template v-for="icType in icTypes">
                                <option :key="icType.text" :value="icType.value">{{ icType.text }}</option>
                            </template>
                        </select>
                        <input type="text" name="ic" data-vv-as="ic" data-vv-validate-on="blur"
                            v-model="ic"
                            v-mask="icType === 1 ? '######-##-####' : null"
                            placeholder="Identity Card Number"
                            :class="{
                            'form-control': true,
                            'is-invalid':  validationErrors.has('ic')
                        }" />
                        <div v-show="validationErrors.has('ic')" class="invalid-feedback">
                            {{ validationErrors.first('ic') }}
                        </div>
                    </div>
                    <button @click="getMcs" class="btn btn-primary">Search</button>
                </div>
                <table ref="listTable" class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th v-if="$store.state.user.userRole !== 1 || isFamily" scope="col">Name</th> <!-- Only display if company or clinic -->
                            <th v-if="$store.state.user.userRole !== 1" scope="col">IC Number</th> <!-- Only display if company or clinic -->
                            <th scope="col">MC Date</th>
                            <th scope="col">Diagnosis</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="mcList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(mc, index) in mcList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                            <!-- <th scope="row">{{mc.idShort}}</th> -->
                            <td v-if="$store.state.user.userRole !== 1 || isFamily">{{mc.name}}</td> <!-- Only display if company or clinic -->
                            <td v-if="$store.state.user.userRole !== 1">{{mc.ic}}</td> <!-- Only display if company or clinic -->
                            <td>{{mc.date}}</td>
                            <td>{{mc.diagnosis}}</td>
                            <td>
                                <a :href="`${apiPath}MedicalCertificate/Get?medicalCertificateId=${mc.id}`" target="_blank">Download</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import 'daterangepicker/daterangepicker';
import pagination from '@/components/pagination';
import popupModal from '@/components/popup-modal';
import { convertToUserReadableDateTime, convertDateToIso8601 } from '@/utilities';
import { VueMaskDirective } from 'v-mask';
import { apiPath } from '@/config';
import icTypes from '@/config/identificationTypes';

export default {
    'components': {
        pagination,
        popupModal
    },
    'directives': {
        // mask,
        'mask': VueMaskDirective
    },
    data () {
        return {
            apiPath,
            icTypes,
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'filterDate': null,
            'filterName': null,
            'ic': null,
            'icType': 1,
            'mcList': []
        };
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        },
        isFamily () {
            return this.$route.name === 'family-medical-certificates-list';
        },
        title () {
            if (this.isFamily) {
                return 'Family Medical Certificate List';
            }
            return 'Medical Certificate List';
        },
        getApi () {
            if (this.isFamily) {
                return 'MedicalCertificate/GetFamilyList';
            }
            return 'MedicalCertificate/GetList';
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getMcs();
            });
        }
    },
    mounted () {
        $('[data-toggle="tooltip"]').tooltip();
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.getMcs();
        this.initializeDatePickers();
    },
    'methods': {
        getMcs () {
            this.isTableLoading = true;

            this.axios.post(this.getApi, {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'fd': convertDateToIso8601(this.filterDate),
                'pn': this.filterName,
                'i': this.ic ? this.ic : null
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.mcList = list.map((mc) => ({
                    'name': mc.n ? mc.n : '-',
                    'ic': mc.i ? mc.i : '-',
                    'date': mc.d ? convertToUserReadableDateTime(mc.d) : '-',
                    'diagnosis': mc.di ? mc.di : '-',
                    'id': mc.mci ? mc.mci : '-',
                    'idShort': mc.mcis ? mc.mcis : '-'
                }));
            });
        },
        initializeDatePickers () {
            $(this.$refs.filterDate).daterangepicker({
                'singleDatePicker': true,
                'autoApply': true,
                'locale': {
                    'format': 'DD/MM/YYYY'
                }
            });

            $(this.$refs.filterDate).on(
                'apply.daterangepicker',
                (ev, picker) => {
                    this.filterDate = picker.startDate.format('DD/MM/YYYY');
                }
            );
        },
        getTitleLabel () {
            return 'Only can view child(ren) aged below 18.\n' +
            'Upon child(ren) attaining age 18 or above, they need to register another personal account with own user ID for migrating their previous medical certificates.';
        }
    }
};
</script>
